<template>
  <div class="flex flex-col gap-3">
    <label class="text-lg  md:text-[28px] font-semibold">{{ trendingTitle }}</label>
    <div v-if="isHamaraMall" class="flex justify-between w-full md:gap-[48px] md:justify-start md:w-auto md:min-h-[126px] min-h-[86px]">
      <div
        v-for="(item, index) in trendingSearches"
        :key="index"
        class="cursor-pointer flex flex-col items-center gap-2"
        @click="handleNavigation(item)"
      >
        <img :src="item.img" :alt="item.name" class="w-[60px] h-[60px] md:w-[90px] md:h-[90px] object-contain" />
        <span class="text-[12px] leading-[100%] md:text-[14px] md:leading-[20px] font-normal text-center tracking-normal font-rubik" style="color: var(--neutrals-black-1-a-1-a-1-a, rgba(26, 26, 26, 1));">
          {{ item.name }}
        </span>
      </div>
    </div>

    <!-- Default badge layout -->
    <div v-else class="flex flex-wrap gap-3">
      <UBadge
        v-for="(item, index) in trendingSearches"
        :key="index"
        color="gray"
        variant="solid"
        size="lg"
        class="cursor-pointer"
        :icon="item.icon"
        :label="item.label"
        @click="handleNavigation(item)"
      />
    </div>
  </div>
</template>
<script setup>
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventCTANames, EventParameter } from '~/google_analytics/events.enum';

const { gtag } = useGtag();
const auth = useAuth();
const isAuthenticated = auth && auth.access_token;
const userData = isAuthenticated ? {
  user_name: auth.user.first_name,
  user_phone: auth.user.phone,
  user_email: auth.user.email,
} : {
  user_name: null,
  user_phone: null,
  user_email: null
};

const runtimeConfig = useRuntimeConfig()
const isHamaraMall = computed(() =>
  runtimeConfig?.public?.partnerCode?.toLowerCase() === 'mall4all'
)
const trendingTitle = computed(() =>
  isHamaraMall.value ? 'Top Trending Searches' : 'Trending Searches'
)
const isVersePartner = computed(() =>
  runtimeConfig?.public?.partnerCode?.toLowerCase() === 'oneindiamall'
)

const hamaraMallItems = [
  { name: 'Electronics', href: '/categories?parent=electronics', img: '/v2/images/electronics.png' },
  { name: 'Deals',       href: '/deals',                         img: '/v2/images/deals.png' },
  { name: 'Grocery',     href: '/categories?parent=grocery',     img: '/v2/images/grocery.png' },
  { name: 'IPL',         href: '/collections/festiveSales',      img: '/v2/images/ipl.png' },
]

const trendingSearches = computed(() => {
  const items = isHamaraMall.value
    ? hamaraMallItems
    : isVersePartner.value
      ? [
          { name: 'Earphones',          href: '/search?q=earphones' },
          { name: 'Skincare',           href: '/search?q=skincare' },
          { name: 'Kitchen containers', href: '/search?q=kitchen+containers' },
          { name: 'Formal Shoes',       href: '/search?q=formal+shoes' },
          { name: 'Grooming',           href: '/search?q=grooming' }
        ]
      : [
          { name: 'Earphones',          href: '/categories?parent=electronics' },
          { name: 'Skincare',           href: '/categories?parent=bpc' },
          { name: 'Kitchen containers', href: '/categories?parent=handk' },
          { name: 'Formal Shoes',       href: '/categories?parent=fashion' },
          { name: 'Grooming',           href: '/categories?parent=fashion' }
        ]

  return items.slice(0, 10).map((item) => ({
    ...item,                    
    icon: 'i-ph-trend-up',
    label: item.name,
  }))
})

const handleNavigation = async (item) => {
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: EventCTANames.TRENDING_SEARCHES,
    [EventParameter.SEARCH_QUERY]: item.name,
  })
  const url = new URL(item.href, window.location.origin);
  const query = Object.fromEntries(url.searchParams.entries());
  await navigateTo({ path: item.href, query });
}
</script>